import EmailIcon from '@mui/icons-material/Email';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import PersonIcon from '@mui/icons-material/Person';
import ShieldIcon from '@mui/icons-material/Shield';

import { EmailReportData } from 'components/DeepSearch/types';

import { CardContainer } from '../../CardContainer';
import { getInitials } from '../utils';

import {
  EmailHeaderRow,
  EmailHeaderLeft,
  HeaderTitle,
  HeaderActions,
  EmailAddress,
  EmailType,
  SectionDivider,
  SectionHeader,
  SectionTitle,
  DetailGrid,
  DetailLabel,
  DetailValue,
  OwnerRow,
  OwnerInfo,
  OwnerAvatar,
  OwnerName,
} from './components';

interface EmailReportPreviewCardProps {
  data: EmailReportData;
}

export const EmailReportPreviewCard = ({
  data,
}: EmailReportPreviewCardProps) => {
  return (
    <CardContainer>
      <EmailHeaderRow>
        <EmailHeaderLeft>
          <EmailIcon fontSize="small" />
          <HeaderTitle>Email Report</HeaderTitle>
        </EmailHeaderLeft>
        <HeaderActions>
          <FileDownloadOutlinedIcon fontSize="small" />
          <OpenInFullOutlinedIcon fontSize="small" />
        </HeaderActions>
      </EmailHeaderRow>

      <EmailAddress>{data.email}</EmailAddress>
      <EmailType>Email Type: {data.emailType}</EmailType>

      <SectionDivider />

      <SectionHeader>
        <ShieldIcon sx={{ fontSize: 18 }} />
        <SectionTitle>FraudScan Summary</SectionTitle>
      </SectionHeader>

      <DetailGrid>
        <DetailLabel>Valid Email:</DetailLabel>
        <DetailValue>{data.validEmail}</DetailValue>
        <DetailLabel>Fraud Score:</DetailLabel>
        <DetailValue>{data.fraudScore}</DetailValue>
        <DetailLabel>Deliverability:</DetailLabel>
        <DetailValue>{data.deliverability}</DetailValue>
        <DetailLabel>Recent Abuse:</DetailLabel>
        <DetailValue>{data.recentAbuse}</DetailValue>
        <DetailLabel>Is leaked:</DetailLabel>
        <DetailValue>{data.isLeaked}</DetailValue>
        <DetailLabel>Spam Trap Score:</DetailLabel>
        <DetailValue>{data.spamTrapScore}</DetailValue>
        <DetailLabel>Is frequent complainer:</DetailLabel>
        <DetailValue>{data.isFrequentComplainer}</DetailValue>
      </DetailGrid>

      <SectionDivider />

      <SectionHeader>
        <PersonIcon sx={{ fontSize: 18 }} />
        <SectionTitle>
          {data.ownersCount} Potential Owner
          {data.ownersCount !== 1 ? 's' : ''} Identified
        </SectionTitle>
      </SectionHeader>

      {data.ownersCount > 0 && (
        <>
          <OwnerRow>
            <OwnerInfo>
              <OwnerAvatar>{getInitials(data.ownerName)}</OwnerAvatar>
              <OwnerName>{data.ownerName}</OwnerName>
            </OwnerInfo>
          </OwnerRow>
          <DetailGrid>
            <DetailLabel>Primary Address:</DetailLabel>
            <DetailValue>{data.primaryAddress}</DetailValue>
            <DetailLabel>Primary Phone:</DetailLabel>
            <DetailValue>{data.primaryPhone}</DetailValue>
            <DetailLabel>Primary Email:</DetailLabel>
            <DetailValue>{data.primaryEmail}</DetailValue>
          </DetailGrid>
        </>
      )}
    </CardContainer>
  );
};
